import { Button, Dropdown, Form, Modal, Spinner } from "react-bootstrap";
import { projectPrimaryColor, projectTertiaryColor } from "../../generalConfigs";
import { useState } from "react";
import { IoWalletOutline } from "react-icons/io5";
import { IoIosMore } from "react-icons/io";
import InputCurrency, { getBalanceInt } from "../../components/shared/InputCurrency";
import { GiFireShield } from "react-icons/gi";
import { MdDone } from "react-icons/md";
import { useHistory } from "react-router-dom";
import { BiError } from "react-icons/bi";
import useWallet from "../../hooks/useWallet";
import Swal from "sweetalert2";
import { AiOutlineClose } from "react-icons/ai";
import useAssets from "../../hooks/useAssets";
import useIcons from "../../hooks/useIcons";
import { parseAssetTypeInt } from "../../utils";

enum eStep {
    WELCOME,
    EXCHANGE,
    BALANCE,
    TOLERANCE,
    ADD_ASSETS,
    DONE,
    ERROR,
}

export default function SetupWallet() {
    const [step, setStep] = useState<eStep>(eStep.WELCOME);
    const [exchange, setExchange] = useState<string>("");
    const [balance, setBalance] = useState<string>("");
    const [balanceGoal, setBalanceGoal] = useState<string>("");
    const [tolerance, setTolerance] = useState<string>("low");
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const { getWalletSuggestions } = useAssets();
    const randomSuggestions = getWalletSuggestions();
    const [assetsToFollow, setAssetsToFolow] = useState(randomSuggestions);

    const { upsertWalletData } = useWallet();
    const { getURI } = useIcons();
    const { push } = useHistory();

    function handleAssetAdd(assetId: string) {
        let newData = assetsToFollow.map((item) => {
            if (item.id === assetId) {
                item.status = !item.status;
            }
            return item;
        });
        setAssetsToFolow(newData);
    }


    const exchanges: { name: string, icon: string }[] = [
        { name: "BTG Pactual", icon: "btg-pactual.png" },
        { name: "Binance", icon: "binance.png" },
        { name: "Nu Invest", icon: "nu-invest.png" },
        { name: "Avenue", icon: "avenue.png" },
        { name: "Inter", icon: "inter.png" },
        { name: "XP", icon: "xp-invest.png" },
        { name: "Rico", icon: "rico.png" },
        { name: "Toro", icon: "toro.png" },
    ]

    async function handleSubmit() {
        setIsLoading(true);

        if (getBalanceInt(balance) > 99999999 || getBalanceInt(balanceGoal) > 99999999) {
            Swal.fire({
                title: "Balanço muito alto!",
                text: 'Para balanços acima de 1 milhão, por favor, entre em contato conosco para assessoria de IA personalizada. Para continuar, reduza o balanço e o balanço meta.',
                icon: "info",
                confirmButtonColor: projectPrimaryColor,
                background: "var(--bg-1)",
                color: "var(--text-1)",
                position: 'top'
            });
            setIsLoading(false);
            return;
        } else if (getBalanceInt(balance) >= getBalanceInt(balanceGoal)) {
            Swal.fire({
                title: "Sem metas?",
                text: 'Sua meta de balanço precisa ser mais alta que seu balanço atual.',
                icon: "info",
                confirmButtonColor: projectPrimaryColor,
                background: "var(--bg-1)",
                color: "var(--text-1)",
                position: 'top'
            });
            setIsLoading(false);
            return;
        }

        const assetsToAdd: string[] = [];

        assetsToFollow.forEach((asset) => {
            if (asset.status) {
                assetsToAdd.push(asset.id);
            }
        })

        const isCreated = await upsertWalletData({
            balance: getBalanceInt(balance),
            balance_goal: getBalanceInt(balanceGoal),
            exchange,
            tolerance,
            assets: assetsToAdd
        });

        if (isCreated) {
            setStep(eStep.DONE);
        } else {
            setStep(eStep.ERROR);
        }

        setIsLoading(false);
    }

    function defineExchange(exchangeName: string) {
        setExchange(exchangeName);
        Swal.fire({
            title: "Integração automática não disponível",
            text: `A integração automática com a corretora ${exchangeName} está temporariamente indisponível, por favor, preencha os dados da sua carteira e adicione os ativos manualmente. Fique tranquilo, o resultado será o mesmo.`,
            icon: "info",
            confirmButtonColor: projectPrimaryColor,
            background: "var(--bg-1)",
            color: "var(--text-1)",
            position: 'top',
            confirmButtonText: 'Continuar'
        });
    }

    function modalBody() {
        if (step === eStep.WELCOME) {
            return <Modal.Body>
                <div className="d-flex justify-content-center">
                    <IoWalletOutline
                        style={{ color: "var(--primary-blue)" }}
                        size={55}
                    />
                </div>
                <h1 className="text-center">
                    Configure sua carteira.
                </h1>
                <p className="tx-15 text-center tx-light">
                    Para utilizar este recurso, você precisa configurar detalhes da sua carteira para treinar nossa I.A de acordo com seu perfil. É bem simples, clique no botão abaixo para continuar.
                </p>

                <div className="d-flex justify-content-center">
                    <Button className="btn btn-primary font-weight-bold rounded-md" onClick={() => setStep(eStep.EXCHANGE)}>
                        Próximo
                    </Button>
                </div>
            </Modal.Body>
        } else if (step === eStep.EXCHANGE) {
            return <Modal.Body>
                <h1 className="text-center">
                    Selecione sua corretora
                </h1>
                <p className="text-center">Este dado será utilizado pela IA para determinar taxas de operações, ativos disponíveis e integração nativa caso esteja disponível.</p>
                <Form.Label>Corretora</Form.Label>
                <Dropdown>
                    <Dropdown.Toggle className="rounded-button wd-100p" variant="secondary">
                        {exchange}
                    </Dropdown.Toggle>

                    <Dropdown.Menu style={{ backgroundColor: 'var(--bg-1)' }} className="wd-100p">
                        {
                            exchanges.map((exchange, index) => (
                                <Dropdown.Item
                                    key={index}
                                    className="dropdown-item-selectable text-center cursor-pointer"
                                    onClick={() => defineExchange(exchange.name)}
                                >
                                    <img
                                        src={`/exchanges/${exchange.icon}`}
                                        alt={exchange.name}
                                        className="wd-30 ht-30 rounded-circle"
                                    />
                                    <span className="mg-l-10">{exchange.name}</span>
                                </Dropdown.Item>
                            ))
                        }

                        <Dropdown.Item
                            className="dropdown-item-selectable text-center cursor-pointer"
                            onClick={() => setExchange('Outros')}
                        >
                            <IoIosMore size={30} />
                            <span className="mg-l-10">Outros</span>
                        </Dropdown.Item>

                    </Dropdown.Menu>
                </Dropdown>

                <div className="d-flex justify-content-center mg-t-20">
                    <Button disabled={!exchange} className="btn btn-primary font-weight-bold rounded-md" onClick={() => {
                        if (exchange) {
                            setStep(eStep.BALANCE);
                        }
                    }}>
                        Próximo
                    </Button>
                </div>
            </Modal.Body>
        } else if (step === eStep.BALANCE) {
            return <Modal.Body>
                <h1 className="text-center">
                    Defina seus balanços
                </h1>
                <p className="text-center">Nossa I.A irá utilizar seu saldo atual e meta para determinar risco e exposições no mercado.</p>

                <Form.Label>Balanço atual</Form.Label>
                <InputCurrency value={balance} setValue={setBalance} />

                <Form.Label>Balanço meta</Form.Label>
                <InputCurrency value={balanceGoal} setValue={setBalanceGoal} />

                <div className="d-flex justify-content-center mg-t-20 gap-8">
                    <Button className="btn btn-secondary rounded-md" onClick={() => {
                        setStep(eStep.EXCHANGE)
                    }}>
                        Voltar
                    </Button>
                    <Button disabled={!balance || !balanceGoal} className="btn btn-primary font-weight-bold rounded-md" onClick={() => {
                        if (balance && balanceGoal) {
                            setStep(eStep.TOLERANCE);
                        }
                    }}>
                        Próximo
                    </Button>
                </div>
            </Modal.Body>
        } else if (step === eStep.TOLERANCE) {

            return <Modal.Body>
                <h1 className="text-center">
                    Defina sua tolerância
                </h1>
                <p className="text-center">Este dado se refere à sua tolerância para perdas, nossa IA vai utilizar estes dados para personalizar suas análises.</p>

                <Form.Label>Tolerância á perdas</Form.Label>
                <Dropdown>
                    <Dropdown.Toggle className="rounded-button wd-100p" variant="secondary">
                        {parseTolerance(tolerance)}
                    </Dropdown.Toggle>

                    <Dropdown.Menu style={{ backgroundColor: 'var(--bg-1)' }} className="wd-100p">
                        <Dropdown.Item
                            className="dropdown-item-selectable text-center cursor-pointer"
                            onClick={() => setTolerance('high')}
                        >
                            <GiFireShield color="var(--green)" size={30} />
                            <span className="mg-l-10">ALTA</span>
                        </Dropdown.Item>

                        <Dropdown.Item
                            className="dropdown-item-selectable text-center cursor-pointer"
                            onClick={() => setTolerance('low')}
                        >
                            <GiFireShield color="var(--red)" size={30} />
                            <span className="mg-l-10">BAIXA</span>
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>

                <div className="d-flex justify-content-center mg-t-20 gap-8">
                    <Button className="btn btn-secondary rounded-md" onClick={() => {
                        setStep(eStep.BALANCE)
                    }}>
                        Voltar
                    </Button>

                    <Button className="btn btn-primary font-weight-bold rounded-md" onClick={() => setStep(eStep.ADD_ASSETS)}>
                        Próximo
                    </Button>
                </div>
            </Modal.Body>
        } else if (step === eStep.ADD_ASSETS) {
            return <Modal.Body>
                <h1 className="text-center">
                    Adicione ativos
                </h1>
                <p className="text-center">É essencial adicionar ativos à sua carteira, dessa forma nossa IA consegue entender o rumo que sua carteira está tomando. Se quiser, adicione alguns dos ativos abaixo da lista de sugestão.</p>

                <div>
                    <div className="wd-lg-100p">
                        <ul className="list-group wd-md-100p">
                            {assetsToFollow.map((asset, i) => {
                                return (
                                    <li
                                        className="list-group-item d-flex align-items-center"
                                        style={{ borderRadius: 10, marginTop: 5 }}
                                        key={i}
                                    >
                                        <img
                                            src={getURI(asset.icon)}
                                            className="wd-30 rounded-circle mg-r-15"
                                            alt=""
                                        />
                                        <div>
                                            <h6 className="tx-13 tx-semibold mg-b-0">
                                                {asset.name}
                                            </h6>
                                            <span className="d-block tx-11 text-muted">
                                                {parseAssetTypeInt(asset.type)}
                                                {asset.exchange &&
                                                    " (" + asset.exchange + ")"}
                                            </span>
                                        </div>
                                        <div
                                            style={{
                                                padding: 2,
                                                marginLeft: "auto",
                                            }}
                                        >
                                            <button
                                                className="btn btn-rounded btn-sm"
                                                type="button"
                                                onClick={() =>
                                                    handleAssetAdd(asset.id)
                                                }
                                                style={{
                                                    backgroundColor: asset.status
                                                        ? "gray"
                                                        : projectTertiaryColor,
                                                    color: "white",
                                                }}
                                            >
                                                {asset.status ? "Remover" : "Adicionar"}
                                            </button>
                                        </div>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>



                <div className="d-flex justify-content-center mg-t-20 gap-8">
                    <Button className="btn btn-secondary rounded-md" onClick={() => {
                        setStep(eStep.TOLERANCE)
                    }}>
                        Voltar
                    </Button>

                    <Button className="btn btn-primary font-weight-bold rounded-md" onClick={() => handleSubmit()}>
                        Finalizar
                    </Button>
                </div>
            </Modal.Body>

        }
        else if (step === eStep.DONE) {
            return <Modal.Body>
                <div className="d-flex justify-content-center">
                    <MdDone
                        style={{ color: "var(--success)" }}
                        size={55}
                    />
                </div>
                <h1 className="text-center">
                    Sucesso
                </h1>
                <p className="tx-15 text-center tx-light">
                    Sua carteira foi configurada com sucesso, clique no botão abaixo para acesssar
                </p>

                <div className="d-flex justify-content-center">
                    <Button className="btn btn-primary font-weight-bold rounded-md" onClick={() => push('/wallet')}>
                        Acessar
                    </Button>
                </div>
            </Modal.Body>
        } else if (step === eStep.ERROR) {
            return <Modal.Body>
                <div className="d-flex justify-content-center">
                    <BiError
                        style={{ color: "var(--danger)" }}
                        size={55}
                    />
                </div>
                <h1 className="text-center">
                    Erro
                </h1>
                <p className="tx-15 text-center tx-light">
                    Ocorreu um erro inesperado, por favor, tente novamente.
                </p>

                <div className="d-flex justify-content-center">
                    <Button className="btn btn-primary font-weight-bold rounded-md" onClick={() => handleSubmit()}>
                        Tentar novamente
                    </Button>
                </div>
            </Modal.Body>
        }

    }

    if (isLoading) {
        return <Modal show={true}>
            <Modal.Body>
                <div className="d-flex justify-content-center">
                    <Spinner animation="border" />
                </div>
            </Modal.Body>
        </Modal>
    }

    return <Modal show={true} onHide={() => push('/')}>
        <Modal.Header>
            <Modal.Title as="h5">Carteira</Modal.Title>
            <AiOutlineClose
                onClick={() => push('/')}
                size={23}
                className="float-right cursor-pointer"
            />
        </Modal.Header>
        {modalBody()}
    </Modal>
}

function parseTolerance(tolerance: string): string {
    if (tolerance === 'low') {
        return 'BAIXA';
    }

    return 'ALTA';
}
